import React, { useState, useEffect, useMemo } from "react";
import { Route, useLocation, Link, useNavigate } from "react-router-dom";
import SearchIcon from "@mui/icons-material/SearchTwoTone";
import AddCircle from "@mui/icons-material/AddCircleRounded";
import _ from "lodash";
import ApiSupplier from "../../../core/api/api.supplier";
import ApiAgent from "../../../core/api/api.agent";
import InsertDriveFile from "@mui/icons-material/InsertDriveFile";

import { FormProvider, useForm, Controller } from "react-hook-form";
import DataGrid from "./DataGrid";
import { ViewAndUpdateSupplier } from "./ViewAndUpdateSupplier";
import { CreateSupplierModal } from "./CreateSupplierModal";
import { tools } from "../../../core/utils/tools";
import EditUserNameModal from "./EditUserNameModal";
import { AddAgentToSupplierModal } from "./AddAgentToSupplierModal";
import ApiAmusementService from "../../../core/api/api.amusementService";
import { InputGroup, Button, FormControl, Col, Accordion, Card, Row, Spinner } from "react-bootstrap";
import SelectComponent from "../_Components/ReactSelectComponent";
import { TextField } from "@mui/material";
import GlobalFormControl from "../_Components/GlobalFormControl";
import ApiRegion from "../../../core/api/api.region";

const Supplier = () => {
  const navigate = useNavigate();
  const [isSelectOtherCityElseKish, setIsSelectOtherCityElseKish] = useState(false)

  const [listData, setListData] = useState({});
  const {
    register,
    handleSubmit,
    control,
    formState: { errors, isSubmitting },
    getValues,
    reset,
    setValue,
    watch,
  } = useForm({});
  const methods = { register, handleSubmit, control, formState: { errors, isSubmitting }, getValues, setValue, watch };
  const [refresh, setRefresh] = useState(false);
  const [showModalSupplier, setShowModalSupplier] = useState(false);
  const [selectedSupplier, setSelectedSupplier] = useState(null);
  const [createModalSupplier, setCreateModalSupplier] = useState(false);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const [showModalEditUserName, setShowModalEditUserName] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [showAddAgentToSupplierModal, setShowAddAgentToSupplierModal] = useState(false);
  const [agents, setAgents] = useState([]);
  const [allAmusementCityList, setAllAmusementCityList] = useState([]);
  const [suppliers, setSuppliers] = useState();
  const pageSizeFromUrl1 = searchParams.get("pageSize");
  const pageSizeFromUrl = !_.isEmpty(pageSizeFromUrl1) ? _.toNumber(pageSizeFromUrl1) : getValues("pageSize");
  const pageNumberFromUrl1 = searchParams.get("pageNumber");
  const pageNumberFromUrl = !_.isEmpty(pageNumberFromUrl1)
    ? _.toNumber(pageNumberFromUrl1)
    : getValues("pageNumber");
  const [isExcel, setIsExcel] = useState(false);

  useEffect(() => {
    (async () => {
      try {

        const data = await ApiSupplier.getAllSupplier({
          ceoFirstName: searchParams.get("ceoFirstName"),
          ceoLastName: searchParams.get("ceoLastName"),
          phoneNumber: searchParams.get("phoneNumber"),
          companyNationalId: searchParams.get("companyNationalId"),
          supplierId: searchParams.get("supplierId"),
          cityIdList: searchParams.get("cityIdList"),
          globalSearch: searchParams.get("globalSearch"),
          pageSize: pageSizeFromUrl,
          pageNumber: pageNumberFromUrl,
        });

        setListData(data);
        setValue("totalCount", data.totalCount);
        const allAgents = await ApiAgent.getAllAgentsName();
        setAgents(allAgents);
        //لیست شهرها
        const allAmusementCityList = await ApiRegion.getAllCity();
        const favoriteCities = allAmusementCityList.filter(city => city.name == "کیش" && city.id != 0).map((item) => ({
          value: item.id,
          label: item.id + "-" + item.name,
        }))
        const otherCities = allAmusementCityList.filter(city => city.name != "کیش" && city.id != 0).map((item) => ({
          value: item.id,
          label: item.id + "-" + item.name,
        }))
        setAllAmusementCityList([
          {
            label: "شهر های مورد علاقه", options: [
              ...favoriteCities,
              {
                value: 0,
                label: "همه شهرها به جز کیش",
              }
            ]
          },
          { label: "همه شهرهای ایران", options: otherCities }
        ]);
        const suppliers = await ApiSupplier.getAllSuppliersName();
        setSuppliers(suppliers);
        const formInputs = [
          { name: "ceoFirstName", type: "text" },
          { name: "ceoLastName", type: "text" },
          { name: "phoneNumber", type: "text" },
          { name: "companyNationalId", type: "text" },
          {
            name: "supplierId",
            type: "multiSelect",
            isMulti: false,
            data: suppliers?.map((item) => ({
              id: item.id,
              title: item.companyName,
            })),
          },
          { name: "cityIdList", type: "multiSelect", isMulti: true, data: allAmusementCityList },
          { name: "globalSearch", type: "text" },
          { name: "pageSize", type: "number" },
          { name: "pageNumber", type: "number" },
        ];
        tools.setInputsValues_ReactHookFrom(setValue, searchParams, formInputs);
      } catch (error) {
        console.log("error :>> ", error);
      } finally {
      }
    })();

    return () => { };
  }, [refresh]);

  useEffect(() => {
    setAllAmusementCityList(prev => {
      const otherCities = prev[1]?.options
      const cities = prev[0]?.options
      const disabledOtherCities = otherCities?.map(city => ({ ...city, isDisabled: isSelectOtherCityElseKish })) || []
      const disabledCities = cities?.map(city => ({ ...city, isDisabled: isSelectOtherCityElseKish })) || []

      return [{ ...prev[0], options: disabledCities }, { ...prev[1], options: disabledOtherCities }]
    })
  }, [isSelectOtherCityElseKish])

  const onSubmit = async (data) => {
    if (data.cityIdList?.length > 0) data.cityIdList = _.toString(data.cityIdList?.map((item) => item.value));
    data.pageNumber = getValues("pageNumber");
    tools.setPageNumber(data, searchParams, setValue);
    data.supplierId = data.supplierId?.value;
    if (isExcel) {
      await ApiSupplier.getSupplierExcel(data).then((response) => {
        const fileBlobUrl = URL.createObjectURL(new Blob([response]));
        const anchor = document.createElement("a");
        anchor.style.display = "none";
        anchor.id = "file" + Math.floor(Math.random() * 100);
        anchor.href = fileBlobUrl;
        anchor.download = "Suppliers.xlsx";
        document.body.appendChild(anchor);
        anchor.click();
      });
      setIsExcel(false)
    }
    const apiData = await ApiSupplier.getAllSupplier(data);

    const queryString = tools.createQueryStringFromFromData(_.omit(data, ["totalPages", "totalCount"]));

    setListData(apiData);
    setValue("totalCount", apiData.totalCount);
    navigate(`/supplierList?${queryString}`);
  };

  const callBackJustForRunUseEffect = () => {
    setRefresh(!refresh);
  };

  return (
    <div>
      <div className={`card card-custom `}>
        {/* Start Box Header */}
        <div className="card-header border-0 pt-5">
          <h3 className="card-title align-items-start flex-column">
            <span className="card-label font-weight-bolder text-dark">مدیریت تامین کننده ها</span>
            <span className="text-muted mt-3 font-weight-bold font-size-sm">لیست تامین کننده های ثبت شده</span>
          </h3>
          <div className="card-toolbar">
            <Button
              onClick={() => {
                setCreateModalSupplier(true);
              }}
            >
              <AddCircle className="mr-1" />
              اضافه کردن تامین کننده
            </Button>
          </div>
        </div>

        {/*Start body */}

        <div className="card-body pt-3 pb-0">
          {/* search box */}
          <div className="border-top pt-3">
            <FormProvider {...methods}>
              <form id="form" onSubmit={methods.handleSubmit(onSubmit)}>
                {/* search box */}
                <Accordion>
                  <Card>
                    <Accordion.Header as={Card.Header} variant="link" eventKey="0">
                      <Card.Title className="py-0 pl-0 fs-normal text-gray">جستجو پیشرفته</Card.Title>
                    </Accordion.Header>
                    <Accordion.Body eventKey="0">
                      <Card.Body>
                        <Row>
                          <Col sm="6" xl="3" className="  px-2 pt-5">
                            <Controller
                              name="supplierId"
                              control={control}
                              render={({ field }) => (
                                <SelectComponent
                                  className="mt-0"
                                  placeholder="شرکت"
                                  options={suppliers?.map((item) => ({
                                    value: item.id,
                                    label: item.companyName,
                                  }))}
                                  field={field}
                                />
                              )}
                            />
                          </Col>
                          <Col sm="6" xl="3" className="tb-reponsive px-2">
                            <Controller
                              name="phoneNumber"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <TextField
                                  label=" شماره تماس"
                                  margin="normal"
                                  variant="outlined"
                                  size="small"
                                  value={value || ""}
                                  onInput={onChange}
                                />
                              )}
                            />
                          </Col>
                          <Col sm="6" xl="3" className="tb-reponsive px-2">
                            <Controller
                              name="ceoFirstName"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <TextField
                                  label="نام مدیر عامل"
                                  margin="normal"
                                  variant="outlined"
                                  size="small"
                                  value={value || ""}
                                  onInput={onChange}
                                />
                              )}
                            />
                          </Col>
                          <Col sm="6" xl="3" className="tb-reponsive px-2">
                            <Controller
                              name="ceoLastName"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <TextField
                                  label="نام خانوادگی مدیر عامل"
                                  margin="normal"
                                  variant="outlined"
                                  size="small"
                                  value={value || ""}
                                  onInput={onChange}
                                />
                              )}
                            />
                          </Col>

                          <Col sm="6" xl="3" className="tb-reponsive px-2">
                            <Controller
                              name="companyNationalId"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <TextField
                                  label=" شناسه ملی شرکت"
                                  margin="normal"
                                  variant="outlined"
                                  size="small"
                                  value={value || ""}
                                  onInput={onChange}
                                />
                              )}
                            />
                          </Col>

                          <Col sm="6" xl="3" className="tb-reponsive px-2">
                            <Controller
                              name="cityIdList"
                              control={control}
                              render={({ field }) => (
                                <SelectComponent
                                  className=" mt-5"
                                  placeholder=" شهر"
                                  options={allAmusementCityList}
                                  isMulti
                                  field={field}
                                  onChange={(selectedCities) => {
                                    let confirmValues = selectedCities;
                                    if (selectedCities.find(item => item.value == 0)) {
                                      setIsSelectOtherCityElseKish(true)
                                      confirmValues = selectedCities.filter(city => city.value == 0)
                                    }
                                    else
                                      setIsSelectOtherCityElseKish(false)
                                    field.onChange(confirmValues)
                                  }}
                                />
                              )}
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col xs="12" className="tb-reponsive mt-3">
                            <Button variant="success" type="submit" disabled={isSubmitting}>
                              {(isSubmitting && !isExcel) && <Spinner animation="border" variant="warning" size="sm" />}
                              <SearchIcon />
                              جستجو
                            </Button>
                            <Button
                              variant="light-danger ml-2"
                              type="submit"
                              disabled={isSubmitting}
                              onClick={() => {
                                setIsSelectOtherCityElseKish(false)
                                tools.handleResetAdvanceSearchBox(watch, reset)
                              }}                            >
                              {(isSubmitting && !isExcel) && <Spinner animation="border" variant="warning" size="sm" />}
                              <i className="fas fa-refresh text-small"></i>
                              حذف جستجو{" "}
                            </Button>
                            <Button
                              className="ml-4"
                              variant="info"
                              type="submit"
                              disabled={isSubmitting}
                              onClick={() => {
                                setIsExcel(true);
                              }}
                            >
                              {(isSubmitting && isExcel) && <Spinner animation="border" variant="warning" size="sm" />}
                              <InsertDriveFile /> فایل اکسل
                            </Button>
                          </Col>
                        </Row>
                      </Card.Body>
                    </Accordion.Body>
                  </Card>
                </Accordion>
                <InputGroup className="my-3">
                  <Controller
                    name="globalSearch"
                    control={control}
                    render={({ field: { onChange, value } }) => (
                      <GlobalFormControl
                        type="text"
                        aria-describedby="basic-addon1"
                        placeholder="جستجو ..."
                        name="globalSearch"
                        value={value || ""}
                        onChange={onChange}
                      />
                    )}
                  />
                  <Button variant="secondary" type="submit" disabled={isSubmitting}>
                    <SearchIcon />
                  </Button>
                </InputGroup>
                {/* table */}
                <Col xs="12" className="tb-reponsive px-0">
                  <DataGrid
                    data={listData}
                    callBack={callBackJustForRunUseEffect}
                    setShowModalSupplier={setShowModalSupplier}
                    setSelectedSupplier={setSelectedSupplier}
                    setShowModalEditUserName={setShowModalEditUserName}
                    setSelectedUserId={setSelectedUserId}
                    setShowAddAgentToSupplierModal={setShowAddAgentToSupplierModal}
                  />
                </Col>
                {showModalSupplier && (
                  <ViewAndUpdateSupplier
                    showModalSupplier={showModalSupplier}
                    setShowModalSupplier={setShowModalSupplier}
                    selectedSupplier={selectedSupplier}
                  />
                )}
              </form>
            </FormProvider>
            {createModalSupplier && (
              <CreateSupplierModal
                createModalSupplier={createModalSupplier}
                setCreateModalSupplier={setCreateModalSupplier}
                callBackJustForRunUseEffect={callBackJustForRunUseEffect}
              />
            )}
            {showModalEditUserName && (
              <EditUserNameModal
                showModalEditUserName={showModalEditUserName}
                setShowModalEditUserName={setShowModalEditUserName}
                selectedUserId={selectedUserId}
              />
            )}
          </div>
          {showAddAgentToSupplierModal && (
            <AddAgentToSupplierModal
              showAddAgentToSupplierModal={showAddAgentToSupplierModal}
              setShowAddAgentToSupplierModal={setShowAddAgentToSupplierModal}
              selectedUserId={selectedUserId}
              agents={agents}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default Supplier;
